import React from 'react';
import { StarIcon } from '@/components/icons';
import { BUSINESS } from '@/lib/site';

export default function GoogleRatingBadge({ compact = false, dark = true }) {
  const bg = dark ? '#060D9C' : '#fff';
  const fg = dark ? '#fff' : '#060D9C';
  const border = dark ? 'rgba(255,255,255,0.16)' : 'rgba(6,13,156,0.15)';
  return (
    <a
      href="https://www.google.com/search?q=National+Forklift+Training+Ltd+Auckland"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-rating-badge"
      className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 transition-colors"
      style={{ background: bg, color: fg, border: `1px solid ${border}` }}
      aria-label={`Google rating ${BUSINESS.rating} stars from ${BUSINESS.reviewCount} reviews`}
    >
      <span className="flex items-center gap-0.5" style={{ color: '#FC4E2C' }}>
        {[0, 1, 2, 3, 4].map((i) => (
          <StarIcon key={i} width={12} height={12} />
        ))}
      </span>
      <span className="font-bold text-sm" style={{ fontFamily: 'Barlow Semi Condensed' }}>
        {BUSINESS.rating}
      </span>
      {!compact && (
        <span className="text-xs opacity-80">· {BUSINESS.reviewCount} Google reviews</span>
      )}
    </a>
  );
}
